<div class="title-area">
  <span class="title-style" [ngClass]="{ disabled: disabled }" [ngStyle]="{'font-size.px': fontSize}">
    {{ title | uppercase }}
  </span>
  <span *ngIf="isMandatory" class="is-mandatory"
    [ngClass]="isConditionFilled ? 'mandatory-valid' : 'mandatory-invalid'"></span>
</div>
